import { render, staticRenderFns } from "./DropPage.vue?vue&type=template&id=5bc58137&scoped=true&"
import script from "./DropPage.vue?vue&type=script&lang=js&"
export * from "./DropPage.vue?vue&type=script&lang=js&"
import style0 from "./DropPage.vue?vue&type=style&index=0&id=5bc58137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc58137",
  null
  
)

export default component.exports